import { render, staticRenderFns } from "./TextWithLines.vue?vue&type=template&id=145a7719&scoped=true&"
import script from "./TextWithLines.vue?vue&type=script&lang=js&"
export * from "./TextWithLines.vue?vue&type=script&lang=js&"
import style0 from "./TextWithLines.vue?vue&type=style&index=0&id=145a7719&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145a7719",
  null
  
)

export default component.exports